var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"mc-icon icon-fill_checkmark"})
}
var staticRenderFns = []

export { render, staticRenderFns }